export default "__VITE_ASSET__DZCAlQGs__"